export const BASE_URL = 'https://test.amplifierapp.xyz/'

export const ENDPOINTS = { 
  GET_VENDORS: 'api_u/list_sellers_contextual_category',
  GET_CATEGORIES_LIST: 'api_u/list_contextual_category',
  VENDOR_DETAIL: 'api_u/businessdetail',
  VENDOR_PRODUCTS: 'api_u/business_products',
  VENDOR_PACKAGES: 'api_u/get_packages',


 
  LOGIN: 'api_s/login',
  REGISTER: 'api_s/register',
  GET_PROFILE: 'api_s/get_profile',
  ADD_VENUE: 'api_s/add_venue',
  UPDATE_VENUE: 'api_s/update_venue',
  DELETE_VENUE: 'api_s/delete_venue',
  LIST_VENDOR_PACKAGES: 'api_s/list_vendor_packages',
  ADD_VENDOR_PACKAGE: 'api_s/add_vendor_package',
  DELETE_VENDOR_PACKAGE: 'api_s/delete_vendor_package',
  UPDATE_VENDOR_PACKAGE: 'api_s/update_vendor_package',
  GET_SUBCATEGORIES: 'api_s/get_subcategories',
}

 

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAdD7A3fCu3lEd1C6-8CVB9auiI3ClgMio',
  authDomain: 'primetime-f5611.firebaseapp.com',
  projectId: 'primetime-f5611',
  storageBucket: 'primetime-f5611.firebasestorage.app',
  messagingSenderId: '256112003489',
  appId: '1:256112003489:web:01be0a9f67716a165563e0',
}
